import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import style from "./Banner.module.css";
import banner from '../../../assets/banner__3.png'

const Banner = () => {
  return (
    <div className={style.banner__container}>
      <Container>
        <Row>
          <Col sm={12} xs={12} md={6} >
            <div className={style.banner__content}>
              <h1>
                <span className={style.hey}>Hey I'm</span> <br /> Zobaer Ahmed{" "}
                <span className={style.name}>Zihad</span>
              </h1>
              <div className={style.text__wrapper}>
                    <h3>I'm a </h3>
                    <div className={style.words}>
                          <span>React Developer</span>
                          <span>Javascript Developer</span>
                          <span>Front-end Developer</span>
                          <span>Full-stack Developer </span>
                          <span>Mern-Stack Developer</span>
                    </div>
                    {/* <h3>Developer</h3> */}
              </div>
              <p>
                A self-motivated and enthusiastic web developer with a deep
                interest in JavaScript. To work in the Software industry with
                modern web technologies of different local & multinational
                Software/ IT agencies of Bangladesh and grow rapidly with
                increasing responsibilities.
              </p>
              <div className={style.banner__button}>
                <a href="https://www.linkedin.com/in/zobaer-ahmed-zihad-48b141211/" target='_blank.'><button className={style.hire__me}>Hire me</button></a>

                <Link to='/contact'><button className={style.get__in__touch}>Get In Touch</button></Link>
              </div>
            </div>
          </Col>
          <Col sm={12} xs={12} md={6} >
            <div className={style.banner__img}>
              <img className="img-fluid" src={banner} alt="" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Banner;
